document.addEventListener('DOMContentLoaded', function () {

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header shadow on scroll + scroll progress ---------- */
  var header = document.getElementById('SiteHeader');
  var progressBar = document.getElementById('ScrollProgress');
  window.addEventListener('scroll', function () {
    if (header) header.style.boxShadow = window.scrollY > 12 ? '0 12px 30px -20px rgba(43,33,27,.35)' : 'none';
    if (progressBar) {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      var pct = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
      progressBar.style.width = pct + '%';
    }
  }, { passive: true });

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('[data-reveal], .card, .review-card, .step');
  if (prefersReduced) {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ---------- Count-up stats ---------- */
  document.querySelectorAll('.count-up').forEach(function (el) {
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      el.textContent = decimals ? target.toFixed(decimals) : target.toLocaleString();
      return;
    }
    var done = false;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !done) {
          done = true;
          var start = null;
          var duration = 1100;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var value = target * progress;
            el.textContent = decimals ? value.toFixed(decimals) : Math.floor(value).toLocaleString();
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = decimals ? target.toFixed(decimals) : target.toLocaleString();
          }
          requestAnimationFrame(step);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(el);
  });

  /* ---------- Button ripple (delegated, covers dynamically-rendered buttons too) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.btn') : null;
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    var ripple = document.createElement('span');
    ripple.className = 'btn-ripple';
    var x = (e.clientX !== undefined && e.clientX !== 0 ? e.clientX - rect.left : rect.width / 2);
    var y = (e.clientY !== undefined && e.clientY !== 0 ? e.clientY - rect.top : rect.height / 2);
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';
    btn.appendChild(ripple);
    setTimeout(function () { ripple.remove(); }, 650);
  });

  /* ---------- Smooth accordion (FAQ + PDP) ---------- */
  document.querySelectorAll('.faq-list details, .pdp-accordion details').forEach(function (details) {
    var summary = details.querySelector('summary');
    var content = details.querySelector('.acc-content');
    if (!summary || !content) return;

    function setState(isOpen) {
      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
      } else {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
      }
    }
    setState(details.hasAttribute('open'));

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = details.hasAttribute('open');
      if (isOpen) {
        setState(false);
        window.setTimeout(function () { details.removeAttribute('open'); }, prefersReduced ? 0 : 380);
      } else {
        details.setAttribute('open', '');
        requestAnimationFrame(function () { setState(true); });
      }
    });
  });

  /* ---------- Hero parallax tilt ---------- */
  var heroVisual = document.querySelector('.hero-visual');
  if (heroVisual && !prefersReduced && window.matchMedia('(pointer:fine)').matches) {
    heroVisual.addEventListener('mousemove', function (e) {
      var rect = heroVisual.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      heroVisual.style.transform = 'rotateX(' + (y * -7) + 'deg) rotateY(' + (x * 7) + 'deg)';
    });
    heroVisual.addEventListener('mouseleave', function () {
      heroVisual.style.transform = 'rotateX(0deg) rotateY(0deg)';
    });
  }

  /* ---------- Spotlight interactive wavelengths ---------- */
  var spotlightVisual = document.querySelector('.spotlight-visual');
  var sr4 = document.querySelector('.sr4');
  if (spotlightVisual && sr4) {
    document.querySelectorAll('.wavelengths li').forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        var dot = li.querySelector('.dot');
        if (!dot) return;
        var color = getComputedStyle(dot).backgroundColor;
        sr4.style.boxShadow = '0 0 46px 8px ' + color;
      });
      li.addEventListener('mouseleave', function () {
        sr4.style.boxShadow = 'none';
      });
    });
  }

  /* =========================================================
     CART DRAWER + AJAX ADD TO CART
  ========================================================= */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.getElementById('CartDrawerOverlay');
  var cartBody = document.getElementById('CartDrawerBody');
  var cartFooter = document.getElementById('CartDrawerFooter');
  var cartCloseBtn = document.getElementById('CartDrawerClose');
  var hasAjaxCart = cartDrawer && window.themeRoutes;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20AC' + amount;
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.classList.add('cart-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.classList.remove('cart-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  function fetchCart() {
    return fetch(window.themeRoutes.cartGet, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function renderCartDrawer(cart) {
    updateCartCount(cart.item_count);
    if (!cartBody || !cartFooter) return cart;

    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p></div>';
      cartFooter.innerHTML = '';
      return cart;
    }

    var rows = cart.items.map(function (item, idx) {
      var line = idx + 1;
      var variant = item.variant_title ? '<p class="cart-variant">' + item.variant_title + '</p>' : '';
      var img = item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '';
      return (
        '<div class="drawer-line">' +
          img +
          '<div class="drawer-line-info">' +
            '<a href="' + item.url + '">' + item.product_title + '</a>' +
            variant +
            '<div class="qty-stepper small">' +
              '<button type="button" data-drawer-qty-minus data-line="' + line + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-drawer-qty-plus data-line="' + line + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="drawer-line-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<button class="drawer-line-remove" data-drawer-remove data-line="' + line + '" aria-label="Remove item">&times;</button>' +
        '</div>'
      );
    }).join('');
    cartBody.innerHTML = rows;

    cartFooter.innerHTML =
      '<div class="cart-subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
      '<p class="cart-note">Shipping and taxes calculated at checkout. Free NL shipping over the threshold shown at checkout.</p>' +
      '<a href="' + window.themeRoutes.checkout + '" class="btn btn-primary btn-block btn-lg">Checkout</a>' +
      '<a href="' + window.themeRoutes.cartPage + '" class="btn btn-outline btn-block" style="margin-top:10px;">View Full Cart</a>';

    cartBody.querySelectorAll('[data-drawer-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-line'), 10);
        var item = cart.items[idx - 1];
        changeLine(idx, item.quantity + 1);
      });
    });
    cartBody.querySelectorAll('[data-drawer-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-line'), 10);
        var item = cart.items[idx - 1];
        changeLine(idx, Math.max(0, item.quantity - 1));
      });
    });
    cartBody.querySelectorAll('[data-drawer-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(parseInt(btn.getAttribute('data-line'), 10), 0);
      });
    });

    return cart;
  }

  function changeLine(line, quantity) {
    fetch(window.themeRoutes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () { window.location.href = window.themeRoutes.cartPage; });
  }

  if (hasAjaxCart) {
    document.querySelectorAll('[data-cart-icon]').forEach(function (icon) {
      icon.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(renderCartDrawer).then(openCartDrawer).catch(function () {
          window.location.href = window.themeRoutes.cartPage;
        });
      });
    });
  }

  function addToCartAjax(form) {
    var formData = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    var originalHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    fetch(window.themeRoutes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { return Promise.reject(err); });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        openCartDrawer();
        if (btn) {
          btn.classList.remove('is-loading');
          btn.innerHTML = 'Added <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="display:inline;vertical-align:-2px;"><path d="M20 6 9 17l-5-5"/></svg>';
          window.setTimeout(function () {
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          }, 1400);
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = originalHTML; }
        form.submit();
      });
  }

  if (hasAjaxCart) {
    document.querySelectorAll('.quick-add-form, #ProductForm').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCartAjax(form);
      });
    });
  }

  /* ---------- Product page: variant picker ---------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    var select = document.getElementById('ProductVariantSelect');
    var optionGroups = document.querySelectorAll('.option-values');
    var addBtn = document.getElementById('AddToCartBtn');
    var addText = document.getElementById('AddToCartText');
    var priceEl = document.getElementById('ProductPrice');
    var compareEl = document.getElementById('ProductComparePrice');
    var mainImage = document.getElementById('MainProductImage');
    var stickyPrice = document.getElementById('StickyPrice');

    function currentSelection() {
      var values = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.option-pill.active');
        if (active) values.push(active.getAttribute('data-option-value'));
      });
      return values.join(' / ');
    }

    function findMatchingOption() {
      if (!select) return null;
      var target = currentSelection();
      if (!target) return select.options[select.selectedIndex];
      var match = null;
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.textContent.trim() === target) match = opt;
      });
      return match;
    }

    function flash(el) {
      if (!el || prefersReduced) return;
      el.classList.remove('price-flash');
      void el.offsetWidth;
      el.classList.add('price-flash');
    }

    function applyOption(opt) {
      if (!opt) return;
      select.value = opt.value;
      var available = opt.getAttribute('data-available') === 'true';
      var hasCompare = opt.getAttribute('data-has-compare') === '1';

      if (priceEl) { priceEl.textContent = opt.getAttribute('data-price'); flash(priceEl); }
      if (compareEl) {
        if (hasCompare) {
          compareEl.textContent = opt.getAttribute('data-compare');
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = !available;
      if (addText) addText.textContent = available ? ('Add to Cart — ' + opt.getAttribute('data-price')) : 'Sold Out';
      if (stickyPrice) { stickyPrice.textContent = opt.getAttribute('data-price'); flash(stickyPrice); }
      var img = opt.getAttribute('data-image');
      if (img && mainImage) mainImage.src = img;
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('active'); });
          pill.classList.add('active');
          applyOption(findMatchingOption());
        });
      });
    });

    /* ---------- Quantity stepper ---------- */
    var qtyInput = document.getElementById('Quantity');
    var minusBtn = document.querySelector('[data-qty-minus]');
    var plusBtn = document.querySelector('[data-qty-plus]');
    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      plusBtn.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    /* ---------- Gallery thumbs ---------- */
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImage) mainImage.src = thumb.getAttribute('data-full');
      });
    });

    /* ---------- Sticky buy bar ---------- */
    var stickyBar = document.getElementById('StickyBuyBar');
    var buyBox = document.querySelector('.product-buybox');
    if (stickyBar && buyBox && 'IntersectionObserver' in window) {
      var barObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      barObserver.observe(buyBox);
    }

    /* ---------- Same-day dispatch countdown ---------- */
    var countdownEl = document.getElementById('DispatchCountdown');
    if (countdownEl) {
      var cutoffHour = parseInt(countdownEl.getAttribute('data-cutoff-hour'), 10) || 15;
      function updateCountdown() {
        var now = new Date();
        var cutoff = new Date(now);
        cutoff.setHours(cutoffHour, 0, 0, 0);
        if (now < cutoff) {
          var diff = cutoff - now;
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          countdownEl.textContent = 'Order within ' + h + 'h ' + m + 'm for same-day dispatch';
        } else {
          countdownEl.textContent = 'Order now — ships tomorrow';
        }
      }
      updateCountdown();
      setInterval(updateCountdown, 60000);
    }
  }
});
